export default {
  title: 'Utilisateurs',
  empty: {
    title: 'Aucun utilisateur',
    message: 'Pour créer un utilisateur, veuillez-vous référer à la documentation.'
  },
  details: {
    'no-friends': 'L\'utilisateur n\'a pas d\'amis'
  }
}



// WEBPACK FOOTER //
// ./src/translations/fr/customer.js